import styled from "styled-components";

const StyledBrandName = styled.strong`
  position: relative;
  display: inline-block;
  padding: 0 0.08em;
  margin: 0 -0.02em;
  background: linear-gradient(105deg, #96b94b 0%, #96b94b 48%, #62a7c0 76%, #3989a6 100%);
  background-clip: text;
  -webkit-background-clip: text;
  color: #96b94b;
  -webkit-text-fill-color: transparent;
  font-family: Roboto-Black;
  font-weight: 700;
  letter-spacing: -0.025em;
  line-height: 1;
  filter: drop-shadow(0 0 12px rgba(150, 185, 75, 0.14));

`;

export const BrandName = () => <StyledBrandName>Essencebit</StyledBrandName>;
